import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCaseData } from '../../features/CaseReducer/CaseReducer';
import { useTranslation } from 'react-i18next';
import CardCase from './CardCase';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import ArrowRight, { ArrowLeft } from '../../Icons/Icon';
import { Link } from 'react-router-dom';
import { SeeMore } from '../../Buttons/Buttons';
import getDirctionLang from '../../Actions/getDirctionLang';
import { Autoplay } from 'swiper/modules';

function CasePage() {
  const dispatch = useDispatch();
  const { cases } = useSelector(state => state.case);
  const { t, i18n } = useTranslation();
  const [swiperKey, setSwiperKey] = useState(Date.now());

  useEffect(() => {
    dispatch(fetchCaseData({ perPage: 6 }));
  }, [dispatch, i18n.language]);

  useEffect(() => {
    setSwiperKey(Date.now());
  }, [cases]);
  
  const isRtl = getDirctionLang();
  return (
            <div className='mx-auto w-full lg:w-10/12 xl:w-10/12 2xl:w-9/12 md:p-10 my-3 mt-5'>

      <div >
        <h1 className="text-3xl font-bold text-gray-900 text-center mb-8">
          {t('cases')}
        </h1>

        {cases?.length > 0 ? (
          <Swiper
            key={i18n.language}
            modules={[Autoplay]}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 3 },
            }}
            dir={isRtl ? "rtl" : "ltr"}
            navigation={{
              nextEl: isRtl ? ".prev" : ".next",
              prevEl: isRtl ? ".next" : ".prev",
              clickable: true,
            }}

            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              waitForTransition: true
            }}
            loop={true}
            spaceBetween={20}
            observer={true}
            observeParents={true}
            className="mySwiper mt-6"
          >
            {cases.map((item, index) => (
              <SwiperSlide key={index}>
                <Link to={`/case/${item.id}`}>
                  <div className=" ">
                    <CardCase data={item} />
                  </div>
                </Link>
              </SwiperSlide>
            ))}
            <ArrowRight></ArrowRight>
            <ArrowLeft />
          </Swiper>
        ) : (
          <div className="text-center py-12 text-gray-600">
            {t('no_cases_available')}
          </div>
        )}
      </div>
      <div className="flex justify-center mt-4">

        <SeeMore link={"/case"} />
      </div>
    </div>
  );
}

export default CasePage;